import { useEffect, useState } from "react";
import { get } from "../../modules/server";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useRound } from "../../modules/roundHandler";
import { DTOBuilding, DTORound } from "../../types/building";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faArrowRight, faBackward, faSnowflake, faSun, faRecycle } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Font } from "devextreme-react/bar-gauge";
import StickyBreadCrumb from "../Global/StickyBreadCrumb";
import { act } from "react-dom/test-utils";
import SunIcon from "../../Assets/sun.svg";
import { Colors } from "../../modules/Colors";
import { ModuleTypeId } from "../../types/DBTables";

interface IStartRoundPageParameters {
  building?: DTOBuilding;
  // onStart: () => void;
  // onResume: () => void;
  // onCancel: () => void;
}

const StartRoundPage = () => {
  const [lastRound, setLastRound] = useState(undefined as undefined | DTORound);
  const { buildingId } = useParams();
  const roundHandler = useRound();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const result = await get("GetDraftRound/" + buildingId);
      if (result.round) setLastRound(result.round);
    })();
  }, []);

  const onStartNewWinterRound = async () => {
    const newRound = await roundHandler.startNewRound(Number(buildingId), false);
    if (newRound) navigate("/round/" + newRound.id + "/0");
  };
  const onStartNewSummerRound = async () => {
    const newRound = await roundHandler.startNewRound(Number(buildingId), true);
    if (newRound) navigate("/round/" + newRound.id + "/0");
  };

  const onResumeLatestRound = async () => {
    if (lastRound) {
      const existingRound = await roundHandler.resumeRound(lastRound);
      if (existingRound) navigate("/round/" + existingRound.id + "/0");
    }
  };

  const onBack = () => {
    navigate("/Buildings/" + buildingId);
  };

  if (buildingId) {
    const bIndex = Number(buildingId);
    const building = roundHandler.getBuilding(bIndex);

    const breadcrumbItems: any[] = [];

    const buildingInfo = building?.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;
    const buildingData = buildingInfo ? JSON.parse(buildingInfo) : undefined;
    const område = buildingData?.område as string;
    breadcrumbItems.push({ text: område + " - " + building?.name, navTo: "/Buildings/" + buildingId });
    breadcrumbItems.push({ text: "Ny rondering", navTo: "/Buildings/" + buildingId, active: true });

    return (
      <>
        <StickyBreadCrumb items={breadcrumbItems} className="mb-2" />
        <Card>
          <Card.Header>{"Du påbörjar nu en rondering av byggnad " + building?.name}</Card.Header>

          <Card.Body>
            <Card.Text>Var vänlig att välj bland alternativen nedan:</Card.Text>

            <Row className="mb-2">
              <Col md={4} className="mt-3">
                <Button variant="primary" onClick={onStartNewWinterRound}>
                  <FontAwesomeIcon icon={faSnowflake} className="me-2" />
                  Starta ny vinter-rondering
                </Button>
                <Col md={4} className="mt-3"></Col>
                <Button variant="warning" onClick={onStartNewSummerRound}>
                  <FontAwesomeIcon icon={faSun} className="me-2" />
                  {/* <span style={{ display: "inline-flex", alignSelf: "center" }}>
                    <img src={SunIcon} className="me-2" alt="Sommar" style={{ height: "1rem", top: "0.125rem", position: "relative" }} />
                  </span> */}
                  Starta ny sommar-rondering
                </Button>
              </Col>
              <Col md={4} className="mt-3">
                {lastRound ? (
                  <Button style={{ backgroundColor: Colors.GrayLight }} onClick={onResumeLatestRound}>
                    <FontAwesomeIcon icon={faRecycle} className="me-2" />
                    Återuppta senaste rondering
                  </Button>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {/* <h6>{"Du påbörjar nu en rondering av byggnad " + building?.name} </h6>

        <div className="mx-3 mb-3">
          <button type="submit" className="mx-3 btn btn-primary" onClick={onStartNewWinterRound}>
            Starta ny vinter-rondering
          </button>
          <button type="submit" className="mx-3 btn btn-primary" onClick={onStartNewSummerRound}>
            Starta ny sommar-rondering
          </button>
          {lastRound ? (
            <button type="submit" className="mx-3 btn btn-primary" onClick={onResumeLatestRound}>
              Återuppta senaste rondering
            </button>
          ) : (
            <></>
          )} */}

        <Button variant="info" className="mt-3" style={{ float: "right" }} onClick={onBack}>
          <FontAwesomeIcon icon={faBackward} />
          <span className="ps-2">Tillbaka</span>
        </Button>
        {/* </div> */}
      </>
    );
  } else return <></>;
};

export default StartRoundPage;
